import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-contrato-vantagens {
  background: linear-gradient(88deg, #600 -1.54%, #970000 23.92%, #C00 102.37%);
  padding: 48px 0 129px;
  position: relative;
}

#emp-garantia-contrato-vantagens .ctn-home-24 {
  z-index: 9;
  position: relative;
}

#emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-titulo {
  color:  #FFF;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin: 0;
}

#emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-subtitulo {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 16px;
}

#emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-cards {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

#emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-card .emp-garantia-contrato-vantagens-card-img {
  width: 40px;
}

#emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-card .emp-garantia-contrato-vantagens-card-text {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
}

#emp-garantia-contrato-vantagens .btn-saiba-mais-emp-garantia-contrato-vantagens {
  width: 272px;
  height: 48px;
  margin: 68px auto 0;
}

#emp-garantia-contrato-vantagens .img-emp-garantia-contrato-vantagens {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  mix-blend-mode: multiply;
}

#emp-garantia-contrato-vantagens .img-emp-garantia-contrato-vantagens-desk {
  display: none;
  mix-blend-mode: multiply;
}

@media (min-width: 992px) {
  #emp-garantia-contrato-vantagens {
    background: linear-gradient(88deg, #600 -1.54%, #970000 23.92%, #C00 102.37%);
    padding: 72px 0;
  }

  #emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-titulo {
    font-size: 56px;
  }

  #emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-subtitulo {
    line-height: 100%;
  }

  #emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-cards {
    flex-direction: row;
    margin-top: 58px;
  }

  #emp-garantia-contrato-vantagens .emp-garantia-contrato-vantagens-card {
    width: 273px;
  }

  #emp-garantia-contrato-vantagens .btn-saiba-mais-emp-garantia-contrato-vantagens {
    margin: 48px 0 0;
  }

  #emp-garantia-contrato-vantagens .img-emp-garantia-contrato-vantagens {
    display: none;
  }

  #emp-garantia-contrato-vantagens .img-emp-garantia-contrato-vantagens-desk {
    display: block;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}`;

export default styles;